export default __webpack_public_path__ + "static/media/helping-old-1.014bbc7f.svg";